<ng-template #idleWarningModal>
  <div class="modal-header border-bottom-0 d-flex justify-content-between align-items-start py-3 px-4">
    <div class="modal-title-wrapper">
      <h5 class="modal-title fw-bold text-center">Session Timeout Warning</h5>
    </div>
  </div>

  <div class="modal-body px-4 py-3">
    <div class="text-center">
      <div class="warning-icon mb-3">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#ffc107"/>
        </svg>
      </div>
      
      <p class="mb-3 text-muted">
        Your session is about to expire due to inactivity.
      </p>
      
      <div class="countdown-timer mb-3">
        <div class="timer-display">
          <span class="timer-value">{{ formatTime(remainingSeconds) }}</span>
        </div>
        <p class="timer-label text-muted small mb-0">Time remaining</p>
      </div>
      
      <p class="mb-0 small text-muted">
        Click "Stay Logged In" to continue your session, or "Logout" to end it now.
      </p>
    </div>
  </div>

  <div class="form-actions modal-footer border-top-0 d-flex justify-content-center gap-3 px-4 pb-4">
    <button
      type="button"
      class="btn btn-light px-4"
      (click)="onLogout()"
    >
      Logout
    </button>
    <button
      type="button"
      class="btn btn-primary px-4"
      (click)="onStayLoggedIn()"
    >
      Stay Logged In
    </button>
  </div>
</ng-template>
